/*
 * COPYRIGHT:     Copyright © 2020 Xplorie LLC
 * Warning:       This product is protected by United States and international copyright laws.
 *                Unauthorized use or duplication of this software, in whole or in part, is prohibited.
 */

export const MODAL_MESSAGE = 'Do you really want to delete the entry?'
export const REMOVE_BUTTON = 'Yes, remove it'
export const CANCEL_BUTTON = 'Cancel'
